import TechnologyChangesType from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologyChangesType";
import TechnologySignalSubType from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologySignalSubType";

const REMOVED_TECHNOLOGY = "Removed technology";
const INSTALLED_TECHNOLOGY = "Installed technology";
const COMPETITOR = "Competitor";
const SUPPORTED_INTEGRATION = "Supported integration";
const POTENTIAL_RENEWAL = "Potential renewal";

export const technologyTypeToTagMap = {
    [TechnologyChangesType.RenewalComingUp]: POTENTIAL_RENEWAL,
    [TechnologyChangesType.Removed]: REMOVED_TECHNOLOGY,
    [TechnologyChangesType.Added]: INSTALLED_TECHNOLOGY,
    [TechnologyChangesType.Renew]: INSTALLED_TECHNOLOGY,
};
export const technologySubTypeToTagMap: Partial<Record<TechnologySignalSubType, string>> = {
    [TechnologySignalSubType.AddedTechnologies]: COMPETITOR,
    [TechnologySignalSubType.RemovedTechnologies]: COMPETITOR,
    [TechnologySignalSubType.AddedIntegrations]: SUPPORTED_INTEGRATION,
    [TechnologySignalSubType.RemovedIntegrations]: SUPPORTED_INTEGRATION,
};
